import {
    ADD_IFSC_USER_MASTER_UPLOAD_SUCCESS, 
    ADD_IFSC_USER_MASTER_UPLOAD_FAILURE, 
    ADD_IFSC_USER_MASTER_UPLOAD_FAILURE_FILE, 
    IFSC_USER_MASTER_TEMPLATE_SUCCESS, 
    IFSC_USER_MASTER_TEMPLATE_FAILURE,
    IFSC_USER_MASTER_DATA_EXCEL_SUCCESS,
    IFSC_USER_MASTER_DATA_EXCEL_FAILURE,
    IFSC_USER_MASTER_LIST_SUCCESS,
    IFSC_USER_MASTER_LIST_FAILURE
} from './action';

const initialState = {
    addIfscUserMasterUploadSuccess: [],
    addIfscUserMasterUploadFailure: [],
    addIfscUserMasterUploadFailureFile: null,
    ifscUserMasterListSuccess: null,
    ifscUserMasterListFailure: null
}

const ifscUserMasterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_IFSC_USER_MASTER_UPLOAD_SUCCESS:
            return state = {
                ...state,
                addIfscUserMasterUploadSuccess: action
            }
        case ADD_IFSC_USER_MASTER_UPLOAD_FAILURE:
            return state = {
                ...state,
                addIfscUserMasterUploadFailure: action
            }
        case ADD_IFSC_USER_MASTER_UPLOAD_FAILURE_FILE:
            return state = {
                ...state,
                addIfscUserMasterUploadFailureFile: action.data
            }

        case IFSC_USER_MASTER_TEMPLATE_SUCCESS:
            return {
                ...state,
                ifscUserMasterTemplateSuccess: action.data
            }

        case IFSC_USER_MASTER_TEMPLATE_FAILURE:
            return {
                ...state,
                ifscUserMasterTemplateFailure: action.data
            }

        case IFSC_USER_MASTER_DATA_EXCEL_SUCCESS:
            return {
                ...state,
                ifscUserMasterDataExcelSuccess: action.data
            }

        case IFSC_USER_MASTER_DATA_EXCEL_FAILURE:
            return {
                ...state,
                ifscUserMasterDataExcelFailure: action.data
            }

        case IFSC_USER_MASTER_LIST_SUCCESS:
            return {
                ...state,
                ifscUserMasterListSuccess: action.data
            };

        case IFSC_USER_MASTER_LIST_FAILURE:
            return {
                ...state,
                ifscUserMasterListFailure: action.data
            };

        default: return state
    }
}

export default ifscUserMasterReducer;
